<template>
	<div>
		<layout-1
		:table_name="'Pictures'"
		:id=pageid
		:searchbar=false
		:navbar=false
		:button_perm="'67'"
		:button_name="'Delete'"
		:term=term
		v-on:select="select"
		style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.PICTURES_DELETE_PAGE,
		}
	},
	methods:{
		select(value){
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid,
						pictureid:value[0],
					}
				}
			).then((res) => {
				router.go(0)
			});

		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/edit/Delete_Pictures.vue